module.exports = __webpack_public_path__ + "img/box-growth.8a05e6ba.png";